export var isIFrame = function isIFrame(e) {
  return null !== e && "IFRAME" === e.tagName;
};